export default __webpack_public_path__ + "static/MainImage2024-c330f74503e5f2baf7aa6e9fcdad954c.png";